import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { FaChevronLeft, FaChevronRight, FaQuoteRight } from 'react-icons/fa';
import API_BASE_URL from '../../api/config';

const FacultyData = () => {
  const scrollRef = useRef(null);
  const [faculties, setFaculties] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch Data
  useEffect(() => {
    const fetchFacultyData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/faculty/read_isShown`);
        const data = response.data;
        const arr = Array.isArray(data) ? data : (data.data || []);
        if (arr.length > 0) {
          const filtered = arr.filter(faculty => faculty.college === 'main');
          const mapped = filtered.map(faculty => ({
            name: faculty.faculty_name,
            title: faculty.faculty_designation,
            image: `https://ethiccraft.org/${faculty.faculty_image}`,
            quote: faculty.faculty_description,
          }));
          setFaculties(mapped);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchFacultyData();
  }, []);

  // Scroll Logic
  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320; // Card width + gap
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="faculty-compact-section">
      <div className="compact-header">
        <h2 className="header-title">Our Faculty</h2>
        <div className="header-line"></div>
        
        {/* Navigation Buttons */}
        <div className="nav-controls">
          <button className="nav-btn prev" onClick={() => scroll('left')} aria-label="Scroll Left">
            <FaChevronLeft />
          </button>
          <button className="nav-btn next" onClick={() => scroll('right')} aria-label="Scroll Right">
            <FaChevronRight />
          </button>
        </div>
      </div>

      {!loading && (
        <div className="faculty-slider-container" ref={scrollRef}>
          {faculties.map((faculty, index) => (
            <div key={index} className="compact-card" tabIndex="0">
              
              {/* Image Layer */}
              <div className="image-layer">
                <img src={faculty.image} alt={faculty.name} loading="lazy" />
                <div className="gradient-overlay"></div>
              </div>

              {/* Text Layer (Always Visible Name/Title) */}
              <div className="info-layer">
                <h3 className="faculty-name">{faculty.name}</h3>
                <p className="faculty-role">{faculty.title}</p>
              </div>

              {/* Hover Layer (Reveals Quote) */}
              <div className="hover-layer">
                <div className="quote-icon"><FaQuoteRight /></div>
                <p className="hover-quote">"{faculty.quote}"</p>
                <div className="gold-bar"></div>
              </div>
              
            </div>
          ))}
          {/* Spacer to ensure last card isn't cut off */}
          <div className="spacer-block"></div>
        </div>
      )}
    </section>
  );
};

export default FacultyData;